export default __webpack_public_path__ + "static/media/potato.45d9e816.png";